module.exports = __webpack_public_path__ + "img/retro-respect.jpg_w545.f1062f52.jpg";